module.exports = __webpack_public_path__ + "loading_360.b0fa629b416a84e13ac9.gif";